import { Avatar } from '@atoms/Avatar';
import { Card, Flex, Stack, Text } from '@mantine/core';
import { FC } from 'react';
import { AuthorsCardProps } from './types';
import { useRouter } from 'next/router';

const AuthorsCard: FC<AuthorsCardProps> = ({
  author,
  imageUrl,
  padding = 'md',
  size = 60,
  isNameFirst = 'inherit',
  isClickDisable = false,
}) => {
  const router = useRouter();

  const onClickAuthor = () => {
    router.push(`/autores/${author.slug}`);
  };

  return (
    <Card
      bg="none"
      padding={padding}
      sx={{ cursor: !isClickDisable ? 'pointer' : 'default' }}
      onClick={!isClickDisable ? onClickAuthor : undefined}
    >
      <Flex gap={10} align="center" dir={isNameFirst}>
        <Avatar
          image={imageUrl ? imageUrl : author.image ? author.image?.key : ''}
          name={author.name}
          size={size}
        />
        <Stack spacing={0}>
          <Text
            variant="caption2White"
            component="p"
            lineClamp={2}
            align="left"
          >
            {author.name}
          </Text>
          <Text variant="caption1Gray" component="span">
            {author.description}
          </Text>
        </Stack>
      </Flex>
    </Card>
  );
};

export default AuthorsCard;
